import { useLayoutEffect } from 'react';

function isCanvas(
  obj: HTMLCanvasElement | HTMLElement | Element,
): obj is HTMLCanvasElement {
  return obj.tagName === 'CANVAS';
}

/**
 * Finds all canvases by class name and sets their width and height to 0 in order to minimize memory leaks, before being removed from the DOM
 */
function useCanvasCleanupByClassName(className: string) {
  useLayoutEffect(() => {
    return () => {
      const elements = Array.from(document.getElementsByClassName(className));
      if (elements.length > 0)
        Array.from(elements).forEach((element) => {
          if (isCanvas(element)) {
            element.width = 0;
            element.height = 0;
          }
        });
    };
  }, []);
}

export default useCanvasCleanupByClassName;
